/**
 * Mock data for Content Moderation
 */

import type { FlaggedContent, ContentType, ModerationStatus } from '../../types/contentModeration';
import { generateId } from './mockData';

const contentTypes: ContentType[] = ['ai-marked', 'user-reported'];
const statuses: ModerationStatus[] = ['pending', 'reviewed', 'action_taken', 'dismissed'];

const flaggingReasons = [
  'Inappropriate Language',
  'Spam Content',
  'Timestamp Inconsistency',
  'Harassment',
  'Violence',
  'False Information',
  'Copyright Violation',
  'Privacy Violation',
];

// Generate mock flagged content matching the image
const generateMockFlaggedContent = (): FlaggedContent[] => {
  const content: FlaggedContent[] = [];
  const now = new Date();

  // Predefined content matching the image
  const predefinedContent: FlaggedContent[] = [
    // Dashboard Case # mappings
    {
      id: generateId(),
      contentId: 'CTX-00734',
      type: 'user-reported',
      reasonForFlagging: 'Timestamp Inconsistency',
      missionId: 'MSN-0734',
      dateFlagged: new Date(now.getTime() - 2 * 60 * 60 * 1000), // 2 hours ago
      status: 'pending',
    },
    {
      id: generateId(),
      contentId: 'CTX-00512',
      type: 'ai-marked',
      reasonForFlagging: 'False Information',
      missionId: 'MSN-0512',
      dateFlagged: new Date(now.getTime() - 24 * 60 * 60 * 1000), // Yesterday
      status: 'pending',
    },
    {
      id: generateId(),
      contentId: 'CTX-84521',
      type: 'ai-marked',
      reasonForFlagging: 'Inappropriate Language',
      missionId: 'MSN-9514',
      dateFlagged: new Date('2023-10-26'),
      status: 'pending',
    },
    {
      id: generateId(),
      contentId: 'CTX-84520',
      type: 'user-reported',
      reasonForFlagging: 'Spam Content',
      missionId: 'MSN-9511',
      dateFlagged: new Date('2023-10-26'),
      status: 'reviewed',
    },
    {
      id: generateId(),
      contentId: 'CTX-84519',
      type: 'ai-marked',
      reasonForFlagging: 'Timestamp Inconsistency',
      missionId: 'MSN-9505',
      dateFlagged: new Date('2023-10-25'),
      status: 'action_taken',
    },
    {
      id: generateId(),
      contentId: 'CTX-84517',
      type: 'user-reported',
      reasonForFlagging: 'Harassment',
      missionId: 'MSN-9501',
      dateFlagged: new Date('2023-10-24'),
      status: 'dismissed',
    },
  ];

  // Generate additional content
  for (let i = 0; i < 20; i++) {
    const contentType = contentTypes[Math.floor(Math.random() * contentTypes.length)];
    const status = statuses[Math.floor(Math.random() * statuses.length)];
    const reason = flaggingReasons[Math.floor(Math.random() * flaggingReasons.length)];
    const dateFlagged = new Date(now.getTime() - (i + 1) * 24 * 60 * 60 * 1000);
    const contentId = `CTX-${Math.floor(Math.random() * 90000) + 10000}`;
    const missionId = `MSN-${Math.floor(Math.random() * 9000) + 1000}`;

    content.push({
      id: generateId(),
      contentId,
      type: contentType,
      reasonForFlagging: reason,
      missionId,
      dateFlagged,
      status,
    });
  }

  return [...predefinedContent, ...content];
};

export const mockFlaggedContent: FlaggedContent[] = generateMockFlaggedContent();

